export const SERVICE_CODE = 'REFERENCE' + '_SERVICE';
